import React, { memo } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import ResultList from './ResultList';

/**
 * Results phase of the Send Test dialog.
 *
 * Three branches:
 *   - no `results` prop yet → renders nothing
 *   - `results.fatalError` (onSubmit rejected) → single red error row with the message
 *   - normal payload → the Braze ResultList (the only test channel). ResultList
 *     itself returns null on empty rows so we don't have to gate the section here.
 */
const SendTestResults = ({ results }) => {
  if (!results) return null;

  if (results.fatalError) {
    return (
      <div className='send-test__results'>
        <div className='send-test__result-row send-test__result-row--error'>
          <FontAwesomeIcon icon={faTimesCircle} />
          <span>{results.fatalError}</span>
        </div>
      </div>
    );
  }

  return (
    <div className='send-test__results'>
      <ResultList
        badgeLabel='Braze'
        badgeClass='send-test__channel-badge--braze'
        rows={results.braze}
      />
    </div>
  );
};

export default memo(SendTestResults);
